import React from 'react';
import ReactDOM from 'react-dom';
// import './styles/index.css';
// import './index.css'; // tailwind postcss'ed


// import App from './App';
import AppRouter from './AppRouter';

ReactDOM.render(<AppRouter />, document.getElementById('root'));